import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { ErrorPagesService } from '../v2/errors/error-pages.service';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule, TitleStrategy } from '@angular/router';
import { PageTitleStrategy } from '../v2/page-title/page-title';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { JftCommonModule } from '../common/common.module';
//import { HotTableModule } from '@handsontable/angular';
import { Router } from "@angular/router";
import * as Sentry from '@sentry/angular';

//========================================================================= App modules
import { AccountModule } from '../account/account.module';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { UserDateParserFormatter } from '../common/helpers/datepicker/formatters/user-date-parser-formatter';
import { AuthModule } from '../auth/auth.module';
import { BuyerModule } from '../buyer/buyer.module';
import { GeodataModule } from '../geodata/geodata.module';
import { IndexesModule } from '../indexes/indexes.module';
import { SupplierModule } from '../supplier/supplier.module';
//========================================================================= Providers
import {
    AppInitializerProvider,
    ChunkLoadNavigationProvider,
    HttpInterceptorsProvider,
    SentryProvider
} from './providers';
//========================================================================= Routing
import { appModuleRoutes } from './routing';

const routerOptions: ExtraOptions = {
    useHash: false,
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload'
};
//========================================================================= Services
import {
    CeleryService,
    LoadingIndicatorService,
    LocalStorageService,
    ToastService
} from './services';
//========================================================================= Components
import { SettingsLandingComponent } from '../common/components/settings-shell/settings-landing.component';
import { SettingsShellComponent } from '../common/components/settings-shell/settings-shell.component';
import { AppComponent } from './layout/app/app.component';
import { LoadingIndicatorComponent } from './layout/loading-indicator/loading-indicator.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { V2BrandComponent } from '../v2/shell/v2-brand.component';
import { EnvBannerComponent } from './layout/env-banner/env-banner.component';
import { ToastsContainerComponent } from './layout/toasts-container/toasts-container.component';
import { MaintenanceModeComponent } from './pages/maintenance-mode/maintenance-mode.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ServiceUnavailableComponent } from './pages/service-unavailable/service-unavailable.component';

@NgModule({ declarations: [
        AppComponent,
        NavbarComponent,
        LoadingIndicatorComponent,
        NotFoundComponent,
        MaintenanceModeComponent,
        ServiceUnavailableComponent,
        ToastsContainerComponent
    ],
    bootstrap: [
        AppComponent
    ], imports: [RouterModule.forRoot(appModuleRoutes, routerOptions),
        NgbModule,
        BrowserModule,
        BrowserAnimationsModule,
        JftCommonModule,
        //HotTableModule.forRoot(),
        FormsModule,
        AccountModule,
        AuthModule,
        IndexesModule,
        SupplierModule,
        BuyerModule,
        GeodataModule,
        SettingsShellComponent,
        EnvBannerComponent,
        V2BrandComponent,
        SettingsLandingComponent], providers: [
        // Angular 22 boots zoneless by default; the app relies on zone.js to refresh after timers,
        // HTTP answers and third-party callbacks, as it did on Angular 20.
        provideZoneChangeDetection(),
        // Sentry's error handler, plus one reload when a lazy chunk is gone after a deploy.
        SentryProvider,
        ChunkLoadNavigationProvider,
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        // Instantiating TraceService is what starts Sentry's route tracing.
        provideAppInitializer(() => { inject(Sentry.TraceService); }),
        provideAppInitializer(() => {
        const initializerFn = (() => () => {
            })();
        return initializerFn();
      }),
        AppInitializerProvider,
        // The device going offline opens the "You Are Offline" page (v2/errors).
        provideAppInitializer(() => inject(ErrorPagesService).watchOffline()),
        // Every ngbDatepicker in the app formats with the airline's chosen date
        // format. Provided here so no component has to remember to do it.
        { provide: NgbDateParserFormatter, useExisting: UserDateParserFormatter },
        // Browser tab titles: "<Page> · <Tender> — Jet Fuel Tenders", env prefix outside production.
        { provide: TitleStrategy, useExisting: PageTitleStrategy },
        HttpInterceptorsProvider,
        LoadingIndicatorService,
        ToastService,
        LocalStorageService,
        CeleryService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule {
}
